export const generateBodyForm = (data: any) => {
  let bodyFormData = new FormData()
  Object.keys(data).forEach((key) => {
    bodyFormData.append(key, data[key])
  })

  return bodyFormData
}
